import BaseComponent from "../../../baseComponent";
import {TechnicalAnalysisWidget} from "../../widgets/technical-analysis-chart/technicalAnalysisWidget.jsx";

export default class TechnicalAnalysis extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let component;
    for (let componentId in this.props.components) {
      component = this.props.components[componentId];
    }
    return (
      <TechnicalAnalysisWidget widget={this.props.widget}
                               components={this.props.components}
                               legends={this.props.model.legends}
                               togglePreloader={() => true}
                               hideLegends={true}
                               componentId={component.controller.id}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/technialAnalysis.jsx